export default function Footer() {
  return (
    <footer class="h-14 min-h-14 w-full overflow-hidden">
      <div class="container-wrapper overflow-hidden">
        <div class="container flex min-h-14 items-center text-muted-foreground text-sm">
          {`© ${new Date().getFullYear()} Positive Traction`}
        </div>
      </div>
    </footer>
  );
}
